import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

interface NuqsProviderProps {
  children: React.ReactNode;
}

/**
 * Provider for nuqs URL state management.
 * Wraps the app to enable URL query parameter sync with React Router v7.
 */
function NuqsProvider({ children }: Readonly<NuqsProviderProps>) {
  return <NuqsAdapter>{children}</NuqsAdapter>;
}

export default NuqsProvider;
